import { memo } from "react";
import { useDrivers } from "../../hooks/useDrivers";
import {
  Alert,
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  TablePagination,
} from "@mui/material";
import LoadingComponent from "../../components/LoadingComponent";
import TableLoader from "../../components/TableLoader";
import DriverFilters from "../../components/DriversFilters";

const MyDrivers = () => {
  const {
    drivers,
    loading,
    error,
    auxSearcher,
    setAuxSearcher,
    pagination,
    driversCount,
    handleChangePage,
    handleChangeRowsPerPage,
  } = useDrivers();

  const handleTablePageChange = (event, newPage) => {
    handleChangePage(newPage + 1);
  };

  const handleRowsPerPageChange = (event) => {
    handleChangeRowsPerPage(parseInt(event.target.value, 10));
  };

  return (
    <>
      {error ? (
        <Alert sx={{ borderRadius: "0px !important" }} severity="error">
          {error}
        </Alert>
      ) : null}
      {loading ? <LoadingComponent /> : null}
      <Grid item xs={12} className="mg-t-20">
        <h2>Mis Drivers</h2>
      </Grid>

      <DriverFilters
        auxSearcher={auxSearcher}
        setAuxSearcher={setAuxSearcher}
      />

      <Grid container>
        <Grid container className="custom-table-container">
          <Grid item xs={12} className="flex-center mg-t-0">
            <>
              <TableContainer>
                {loading && <TableLoader />}
                <Table aria-label="tabla de drivers" className="fixed-table">
                  <TableHead sx={{ backgroundColor: "#fff" }}>
                    <TableRow>
                      <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          indeterminate={false}
                          checked={false}
                          onChange={() => {}}
                          inputProps={{ "aria-label": "select all" }}
                        />
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold" }}>ID</TableCell>
                      <TableCell sx={{ fontWeight: "bold" }}>Nombre</TableCell>
                      <TableCell sx={{ fontWeight: "bold" }}>RUT</TableCell>
                      <TableCell sx={{ fontWeight: "bold" }}>
                        Teléfono
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold" }}>Email</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {drivers.length === 0 || loading ? (
                      <>
                        <TableRow
                          key={"driver-not-found"}
                          sx={{
                            "& > *": { borderBottom: "unset" },
                            backgroundColor: "#fff",
                          }}
                        >
                          <TableCell
                            component="th"
                            scope="row"
                            colSpan={6}
                            align="center"
                          >
                            <Typography color="text.secondary">
                              No se encontraron drivers.
                            </Typography>
                          </TableCell>
                        </TableRow>
                      </>
                    ) : (
                      <>
                        {!loading &&
                          drivers.map((driver) => (
                            <TableRow
                              key={driver.id}
                              sx={{
                                "& > *": { borderBottom: "unset" },
                                backgroundColor: "#fff",
                              }}
                            >
                              <TableCell component="th" scope="row">
                                <Checkbox
                                  color="primary"
                                  checked={false}
                                  onChange={() => {}}
                                />
                              </TableCell>

                              <TableCell component="th" scope="row">
                                {driver.id}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {driver.full_name || "Sin nombre"}
                              </TableCell>
                              <TableCell>{driver.rut}</TableCell>
                              <TableCell>{driver.phone}</TableCell>
                              <TableCell>{driver.email}</TableCell>
                            </TableRow>
                          ))}
                      </>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[20, 40, 60, 80, 100]}
                component="div"
                count={driversCount}
                rowsPerPage={pagination.rowsPerPage}
                page={pagination.page - 1}
                onPageChange={handleTablePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
                labelDisplayedRows={({ from, to, count }) => {
                  return `Mostrando ${from}-${to} de ${count}`;
                }}
                labelRowsPerPage={"Filas por página:"}
              />
            </>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default memo(MyDrivers);
